import base from "../baseurl";
import token from "../getTk";

const Delete = async (id) => {
  console.log("llego al delte", id);
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Delete = await api
    .post("industrial-parks/delete", {
      json: {
        id,
      },
    })
    .json();

  return Delete;
};

export default Delete;
